import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  InputGroup,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import loader from "../../../style/loader/loader.scss";
import { removeChildContract } from "../../../redux/actions/contractActions";
import Attributes from "./Attributes";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let offerTitle = [],
  french_offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  activateQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  percentageOff = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  remittanceVal =[],
  stockmanage=[],
  offerPriceVal = [],
  incrementalRedemption = [],
  maxAsGift = [],
  vouchers = [],
  RecurringBillingCycle = [],
  RecurringofferPrice = [],
  RecurringretailPrice = [],
  Days = [],
  BillingPeriodOptions = [],
  updatedDate = [];


class AdditionalPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateOption: this.props.affiliateOption,
      contractType: (this.props.contractType!='' ? this.props.contractType : (this.props.priceData ? this.props.priceData.proposal_type : '')),
      indexKey: this.props.indexKey,
      attributeStatus: false,
      attributes: "",
      priceData: this.props.priceData ? this.props.priceData : "",
      stockmanage: this.props.stockmanage ?this.props.stockmanage : "",
      datedisable: false,
      incRed: 0,
      monthdisable: false,
      multi_lang: 'no',
      offerPriceVal: "",
      remittanceVal: "",
      hideMsg: false,
      BillingPeriodOptions: this.props.priceData.BillingPeriodOptions,
    };

    expirationMonth[this.props.indexKey] = "";
    expirationDate[this.props.indexKey] = null;
    incrementalRedemption[this.props.indexKey] = "0";
  }

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };

  componentDidMount() { 
    this.setState({remittanceVal: this.props.priceData.remittance, offerPriceVal: this.props.priceData.offerPrice, incrementalRedemption: this.props.priceData.incrementalRedemption, BillingPeriodOptions: this.props.priceData.BillingPeriodOptions, contractType: (this.props.contractType!='' ? this.props.contractType : (this.props.priceData ? this.props.priceData.proposal_type : '')), vouchers: this.props.priceData.vouchers});
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    if (this.state.priceData == "") {
      offerTitle[this.state.indexKey] = "";
      french_offerTitle[this.state.indexKey] = "";
      expirationMonth[this.state.indexKey] = "";
      expirationDate[this.state.indexKey] = "";
      minQuantity[this.state.indexKey] = "";
      activateQuantity[this.state.indexKey] = "";
      skuCode[this.state.indexKey] = "";
      maxPerCustomer[this.state.indexKey] = "";
      percentageOff[this.state.indexKey] = "";
      maxAvailable[this.state.indexKey] = "";
      retailPrice[this.state.indexKey] = "";
      offerPrice[this.state.indexKey] = "";
      stockmanage[this.state.indexKey] = "";
      remittance[this.state.indexKey] = "";
      incrementalRedemption[this.state.indexKey] = "";
      maxAsGift[this.state.indexKey] = "";
      RecurringBillingCycle[this.state.indexKey] = "";
      RecurringofferPrice[this.state.indexKey] = "";
      RecurringretailPrice[this.state.indexKey] = "";
      Days[this.state.indexKey] = "";
      BillingPeriodOptions[this.state.indexKey] = "";
    }
    
  }

  componentWillReceiveProps(nextProps) {}

  removePriceDetail = e => {
    let getContractID = e.target.attributes.getNamedItem("data-key").value;
    if (getContractID != '') {
      this.props.removeChildContract(getContractID);
      this.props.removePriceDetail(this.state.indexKey, getContractID);
    }else{
      this.props.removePriceDetail(this.state.indexKey, getContractID);
    }
  };

  handleOfferChange = e => {
    offerTitle[this.state.indexKey] = e.target.value;
    this.props.handleOfferChange(e.target.value, this.state.indexKey);
  };

  handleFrenchOfferChange = e => {
    french_offerTitle[this.state.indexKey] = e.target.value;
    this.props.handleFrenchOfferChange(e.target.value, this.state.indexKey);
  };

  handleexpirationMonthChange = e => {
    expirationMonth[this.state.indexKey] = e.target.value;
    if (expirationMonth[this.state.indexKey] != "") {
      this.setState({ datedisable: true });
    } else {
      this.setState({ datedisable: false });
    }
    this.props.handleexpirationMonthChange(e.target.value, this.state.indexKey);
  };

  handleexpirationDateChange = date => {
    // this.setState({ expirationDate : date });
    expirationDate[this.state.indexKey] = date ? date : ""
    if (expirationDate[this.state.indexKey] != "") {
      this.setState({ monthdisable: true }); 
    } else {
      this.setState({ monthdisable: false }); 
    }
    if (this.props.priceData) {
      this.props.handleUpdate('expirationDate', date, this.state.indexKey);
    } else {
      this.props.handleexpirationDateChange(date, this.state.indexKey);
    }
  };

  handleminQuantityChange = e => {
    minQuantity[this.state.indexKey] = e.target.value;
    this.props.handleminQuantityChange(e.target.value, this.state.indexKey);
  };

  handleActiveQuantityChange = e => {
    activateQuantity[this.state.indexKey] = e.target.value;
    this.props.handleActiveQuantityChange(e.target.value, this.state.indexKey);
  };

  handleskuCodeChange = e => {
    skuCode[this.state.indexKey] = e.target.value;
    this.props.handleskuCodeChange(e.target.value, this.state.indexKey);
  };

  handleStockChange = e => {
    skuCode[this.state.indexKey] = e.target.value;
    this.props.handleStockChange(e.target.value, this.state.indexKey);
  };


  handlemaxPerCustomerChange = e => {
    maxPerCustomer[this.state.indexKey] = e.target.value;
    this.props.handlemaxPerCustomerChange(e.target.value, this.state.indexKey);
  };

  handlepercentageOffChange = e => {
    percentageOff[this.state.indexKey] = e.target.value;
    this.props.handlepercentageOffChange(e.target.value, this.state.indexKey);
    const hideMsg = e.target.value > 100 ? true : false; 
    this.setState({ hideMsg: hideMsg});
  };

  handlemaxAvailableChange = e => {
    maxAvailable[this.state.indexKey] = e.target.value;
    this.props.handlemaxAvailableChange(e.target.value, this.state.indexKey);
  };

  handleretailPriceChange = e => {
    retailPrice[this.state.indexKey] = e.target.value;
    this.props.handleretailPriceChange(e.target.value, this.state.indexKey);
  };

  handleofferPriceChange = e => {
    offerPrice[this.state.indexKey] = e.target.value;
    this.props.handleofferPriceChange(e.target.value, this.state.indexKey);
    this.setState({ offerPriceVal: offerPrice[this.state.indexKey] });
  };

  handleremittanceChange = e => {
    remittance[this.state.indexKey] = e.target.value;    
    this.props.handleremittanceChange(e.target.value, this.state.indexKey);
    this.setState({ remittanceVal: remittance[this.state.indexKey] });
  };

  handleincrementalRedemptionChange = e => {
    incrementalRedemption[this.state.indexKey] = e.target.value;
    this.props.handleincrementalRedemptionChange(
      e.target.value,
      this.state.indexKey
    );
    if (e.target.value == 0) {
      vouchers[this.state.indexKey] = "";
      this.setState({ vouchers: vouchers[this.state.indexKey]});
      this.props.handleGenerateVoucher(
      "",
      this.state.indexKey
      );
    }
    this.setState({incRed: e.target.value});
  };

  handleGenerateVoucher = e => {
    vouchers[this.state.indexKey] = e.target.value;
    this.props.handleGenerateVoucher(
      e.target.value,
      this.state.indexKey
    );
  };

  handlemaxAsGiftChange = e => {
    maxAsGift[this.state.indexKey] = e.target.value;
    this.props.handlemaxAsGiftChange(e.target.value, this.state.indexKey);
  };

  handleRecurringBillingCycleChange = e => {
    RecurringBillingCycle[this.state.indexKey] = e.target.value;
    this.props.handleRecurringBillingCycleChange(e.target.value, this.state.indexKey);
  };

  handleRecurringofferPriceChange = e => {
    RecurringofferPrice[this.state.indexKey] = e.target.value;
    this.props.handleRecurringofferPriceChange(e.target.value, this.state.indexKey);
  };

  handleRecurringretailPriceChange = e => {
    RecurringretailPrice[this.state.indexKey] = e.target.value;
    this.props.handleRecurringretailPriceChange(e.target.value, this.state.indexKey);
  };

  handleDaysChange = e => {
    Days[this.state.indexKey] = e.target.value;
    this.props.handleDaysChange(e.target.value, this.state.indexKey);
  };

  handleBillingPeriodOptionsChange = e => { 
    BillingPeriodOptions[this.state.indexKey] = e.target.value;
    this.props.handleBillingPeriodOptionsChange(e.target.value, this.state.indexKey);
    this.setState({ BillingPeriodOptions: e.target.value });
  };

  attributeData = (data, idx) => {  
    if (this.props.priceData) {
      this.props.handleUpdate("attributes", data, this.state.indexKey);
    } else {
      this.props.attributeData(data, this.state.indexKey);
    }
  };

  matrixData = (data, idx) => {
    if (this.props.priceData) {
      this.props.handleUpdate("metrix", data, this.state.indexKey);
    } else {
      this.props.matrixData(data, this.state.indexKey);
    }
  };

  handleUpdate = e => {
    if (e.target.name == "expirationMonth") {
      if (e.target.value == "") {
        this.setState({ datedisable: false });
      }
    }

    if (e.target.name == "incrementalRedemption") {
      if(e.target.value == 0){
        vouchers[this.state.indexKey] = "";
        this.setState({ incrementalRedemption: 0, vouchers: vouchers[this.state.indexKey]});
      }else{
       this.setState({ incrementalRedemption: 1}); 
      }      
    }

    this.props.handleUpdate(e.target.name, e.target.value, this.state.indexKey);

    if (e.target.name == "remittance") {
      this.setState({ remittanceVal: e.target.value });
    }
    if (e.target.name == "offerPrice") {
      this.setState({ offerPriceVal: e.target.value });
    }

    if (e.target.name == "BillingPeriodOptions") {
      this.setState({ BillingPeriodOptions: e.target.value });
    }
    if (e.target.name == "percentageOff") {
      const hideMsg = e.target.value > 100 ? true : false; 
      this.setState({ hideMsg: hideMsg});
    }    
  };


  render() {
    return (
      <Row key={this.state.indexKey}>
        <div className="col-lg-12 add-sub-admin">
          {/**start contract price information **/}
          <div className="panel">
            <header className="panel-heading">
              Pricing Detail{" "}
              <Button
                bsSize="small"
                bsStyle="danger"
                className="pull-right"
                data-key={
                  this.state.priceData ? this.state.priceData.contractID : ""
                }
                onClick={this.removePriceDetail}
              >
                Remove
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Offer Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          offerTitle[this.state.indexKey]
                            ? offerTitle[this.state.indexKey]
                            : this.props.priceData.offerTitle
                        }
                        placeholder="Offer Title"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleOfferChange
                        }
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {(this.state.multi_lang == "yes") &&
                    <FormGroup controlId="french_offerTitle">
                      <ControlLabel>
                        Offer Title (Canadian French)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          french_offerTitle[this.state.indexKey]
                            ? french_offerTitle[this.state.indexKey]
                            : this.props.priceData.french_offerTitle
                        }
                        placeholder="Offer Title"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleFrenchOfferChange
                        }
                        name="french_offerTitle"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    }
                    <FormGroup controlId="formExpirationMonth">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> How Long Until Purchased Vouchers Expire?
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.expirationMonthError }}
                        name="expirationMonth"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleexpirationMonthChange
                        }
                        defaultValue={(expirationMonth[this.state.indexKey]) ? expirationMonth[this.state.indexKey] : this.props.priceData.expirationMonth}
                        disabled={this.state.monthdisable}
                        key={Math.random()}
                      >
                        <option value="">None</option>
                        <option value="1">1 Months</option>
                        <option value="2">2 Months</option>
                        <option value="3">3 Months</option>
                        <option value="4">4 Months</option>
                        <option value="5">5 Months</option>
                        <option value="6">6 Months</option>
                        <option value="7">7 Months</option>
                        <option value="8">8 Months</option>
                        <option value="9">9 Months</option>
                        <option value="10">10 Months</option>
                        <option value="11">11 Months</option>
                        <option value="12">12 Months</option>
                        <option value="18">18 Months</option>
                        <option value="84">7 Years</option>
                        <option value="0">Never Expires</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formExpirationDate">
                      <ControlLabel>or</ControlLabel>
                      <DatePicker
                        onChange={
                            this.handleexpirationDateChange
                          }
                        value={ expirationDate[this.state.indexKey] !== null && expirationDate[this.state.indexKey] !== undefined ? ( expirationDate[this.state.indexKey] ) : (this.props.priceData.expirationDate ? new Date(moment(this.props.priceData.expirationDate).format().replace(/-/g, '\/').replace(/T.+/, '')) : '') }
                        style={{ borderColor: this.state.expirationDateError }}
                        disabled={this.state.datedisable}
                      />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>Minimum Quantity Required Per Customer</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          placeholder="Minimum Quantity Required Per Customer"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleminQuantityChange
                          }
                          name="minQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                          defaultValue={
                            minQuantity[this.state.indexKey]
                              ? minQuantity[this.state.indexKey]
                              : this.props.priceData.minQuantity
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.affiliateOption == false /*false*/ ? (
                      <ControlLabel>Minimum Quantity Required To Activate Offer</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false /*false*/ ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          placeholder="Minimum Quantity Required To Activate Offer"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleActiveQuantityChange
                          }
                          name="activateQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                          defaultValue={
                            activateQuantity[this.state.indexKey]
                              ? activateQuantity[this.state.indexKey]
                              : this.props.priceData.activateQuantity
                          }
                          disabled={this.state.contractType==9 ? true :false}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        SKU #
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formSkuCode">
                        <FormControl
                          type="text"
                          placeholder="SKU Code"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleskuCodeChange
                          }
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                          defaultValue={
                            skuCode[this.state.indexKey]
                              ? skuCode[this.state.indexKey]
                              : this.props.priceData.skuCode
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        Max Per Customer
                        (leave blank for an unlimited amount)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMaxPerCustomer">
                        <FormControl
                          type="number"
                          placeholder="Max Per Customer"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlemaxPerCustomerChange
                          }
                          name="maxPerCustomer"
                          style={{
                            borderColor: this.state.maxPerCustomerError
                          }}
                          defaultValue={
                            maxPerCustomer[this.state.indexKey]
                              ? maxPerCustomer[this.state.indexKey]
                              : this.props.priceData.maxPerCustomer
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}


                      <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                         Manage Stock?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="stockmanage"
                          onChange={this.props.priceData ? this.handleUpdate
                          :this.state.handleStockChange }

                              defaultValue={
                            stockmanage[this.state.indexKey]
                              ? stockmanage[this.state.indexKey]
                              : this.props.priceData.stockmanage
                          }
                        
                        >
                             <option value="1">In Stock</option>
                          <option value="2">Out of Stock</option>
                     
                        </FormControl>
                      </FormGroup>

                    {this.state.contractType == '9' ? (
                      <FormGroup
                        controlId="formBillingPeriodOptions" 
                      >
                        <ControlLabel>
                          Billing Period Options
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          defaultValue={this.state.BillingPeriodOptions}
                          value={this.state.BillingPeriodOptions}
                          placeholder="End Recurring Billing after"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleBillingPeriodOptionsChange
                          }
                          name="BillingPeriodOptions"
                          style={{ borderColor: this.state.BillingPeriodOptionsError }}
                        >
                          <option value="Yearly">Yearly</option>
                          <option value="HalfYearly">Half Yearly</option>
                          <option value="Quarterly">Quarterly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Days">Every Specific Days</option>
                        </FormControl> 
                      </FormGroup>
                    ) : null} 
                    {this.state.BillingPeriodOptions == 'Days' ? (
                      <FormGroup
                        controlId="formDays" 
                      >
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Specific Days
                        </ControlLabel>
                        <FormControl
                          type="number"
                          defaultValue={
                            Days[this.state.indexKey]
                              ? Days[this.state.indexKey]
                              : this.props.priceData.Days
                          } 
                          placeholder="Specific Days"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleDaysChange
                          }
                          name="Days"
                          style={{ borderColor: this.state.DaysError }}
                        /> 
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={6} xs={12}>
                  {this.state.affiliateOption == true ? (
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Percentage Off (Input 0-100) 
                      {this.state.hideMsg == true ? (
                          <span style={{ color: "red" }}>(Please input between 0 to 100 )</span>
                        ) : null} 
                    </ControlLabel>
                    ) : null}
                  {this.state.affiliateOption == true ? (
                    <FormGroup controlId="formPercentageOff">
                      <FormControl
                        type="number"
                        placeholder="Percentage Off"
                        onChange={
                          this.props.priceData
                          ? this.handleUpdate
                          : this.handlepercentageOffChange
                        }
                        name="percentageOff"
                        style={{ borderColor: this.state.percentageOffError }}
                        defaultValue={
                          percentageOff[this.state.indexKey]
                          ? percentageOff[this.state.indexKey]
                          : this.props.priceData.percentageOff
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    ) : null}
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Maximum Available
                    </ControlLabel>
                    <FormGroup controlId="formMaxAvailable">
                      <FormControl
                        type="number"
                        placeholder="Maximum Available"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handlemaxAvailableChange
                        }
                        name="maxAvailable"
                        style={{ borderColor: this.state.maxAvailableError }}
                        defaultValue={
                          maxAvailable[this.state.indexKey]
                            ? maxAvailable[this.state.indexKey]
                            : this.props.priceData.maxAvailable
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span>{(this.state.contractType=='9' ? 'Initial' : '')} Retail Price
                    </ControlLabel>
                    <FormGroup controlId="formRetailPrice">
                      <FormControl
                        type="number"
                        placeholder={(this.state.contractType=='9' ? 'Initial' : '') + "Retail Price"} 
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleretailPriceChange
                        }
                        name="retailPrice"
                        style={{ borderColor: this.state.retailPriceError }}
                        defaultValue={
                          retailPrice[this.state.indexKey]
                            ? retailPrice[this.state.indexKey]
                            : this.props.priceData.retailPrice
                        }
                        readOnly = {this.state.affiliateOption == false ? false : true}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span>{(this.state.contractType=='9' ? 'Initial' : '')} Offer Price
                    </ControlLabel>
                    <FormGroup controlId="formOfferPrice">
                      <FormControl
                        type="number"
                        placeholder={(this.state.contractType=='9' ? 'Initial' : '') + "Offer Price"}
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleofferPriceChange
                        }
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                        defaultValue={
                          offerPrice[this.state.indexKey]
                            ? offerPrice[this.state.indexKey]
                            : this.props.priceData.offerPrice
                        }
                        readOnly = {this.state.affiliateOption == false ? false : true}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {(this.state.affiliateOption == false && this.state.offerPriceVal !='') ? 
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) 
                        ({(this.state.offerPriceVal > 0) ? parseFloat(((this.state.offerPriceVal -  (this.state.remittanceVal ? this.state.remittanceVal : 0.00))/ this.state.offerPriceVal)*100).toFixed(2) : 0.00} % Margin)
                      </ControlLabel>
                     : this.state.affiliateOption == false ? 
                    <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) (0.00 % Margin)
                      </ControlLabel>
                    : null
                    }
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          placeholder="Remittance Per Unit"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleremittanceChange
                          }
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                          defaultValue={
                            remittance[this.state.indexKey]
                              ? remittance[this.state.indexKey]
                              : this.props.priceData.remittance
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                          Will this offer generate multiple vouchers?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="incrementalRedemption"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleincrementalRedemptionChange
                          }
                          defaultValue={
                            this.props.priceData.incrementalRedemption
                              ? this.props.priceData.incrementalRedemption
                              : incrementalRedemption[this.state.indexKey]
                          }
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    ) : null}

                    {(this.state.incRed == '1' || this.state.incrementalRedemption == '1') &&
                    <FormGroup>
                      <ControlLabel>Number of Vouchers to Generate Per Order (each voucher will reflect the retail price divided by the number below. A $25 order / 5 vouchers = $5 value each)</ControlLabel>
                      <FormControl
                        type="number"
                        defaultValue={this.state.vouchers ? this.state.vouchers : vouchers[this.state.indexKey]}
                        placeholder="Enter Voucher Value"
                        onChange={this.props.priceData
                              ? this.handleUpdate
                              : this.handleGenerateVoucher
                            }
                        name="vouchers"
                      />
                    </FormGroup>
                    }
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max As Gifts (Do
                        not leave blank. Add 0 for no additional vouchers. No
                        unlimited option)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMaxAsGift">
                        <FormControl
                          type="number"
                          placeholder="Max As Gifts"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlemaxAsGiftChange
                          }
                          name="maxAsGift"
                          style={{ borderColor: this.state.maxAsGiftError }}
                          defaultValue={
                            maxAsGift[this.state.indexKey]
                              ? maxAsGift[this.state.indexKey]
                              : this.props.priceData.maxAsGift
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == '9' ? (
                      <FormGroup
                        controlId="formRecurringretailPrice" 
                      >
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Recurring Retail Price
                        </ControlLabel>
                        <FormControl
                          type="number"
                          defaultValue={
                            RecurringretailPrice[this.state.indexKey]
                              ? RecurringretailPrice[this.state.indexKey]
                              : this.props.priceData.RecurringretailPrice
                          } 
                          placeholder="Recurring Retail Price"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleRecurringretailPriceChange
                          }
                          name="RecurringretailPrice"
                          style={{ borderColor: this.state.RecurringretailPriceError }}
                        /> 
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == '9' ? (
                      <FormGroup
                        controlId="formRecurringofferPrice" 
                      >
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Recurring Offer Price
                        </ControlLabel>
                        <FormControl
                          type="number"
                          defaultValue={
                            RecurringofferPrice[this.state.indexKey]
                              ? RecurringofferPrice[this.state.indexKey]
                              : this.props.priceData.RecurringofferPrice
                          }  
                          placeholder="Recurring Offer Price"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleRecurringofferPriceChange
                          }
                          name="RecurringofferPrice"
                          style={{ borderColor: this.state.RecurringofferPriceError }}
                        /> 
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == '9' ? (
                      <FormGroup
                        controlId="formRecurringBillingCycle" 
                      >
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>End Recurring Billing after
                        </ControlLabel>
                        <InputGroup>
                          <FormControl
                            type="number"
                            defaultValue={
                              RecurringBillingCycle[this.state.indexKey]
                                ? RecurringBillingCycle[this.state.indexKey]
                                : this.props.priceData.RecurringBillingCycle
                            }
                            placeholder="End Recurring Billing after"
                            onChange={
                              this.props.priceData
                                ? this.handleUpdate
                                : this.handleRecurringBillingCycleChange
                            }
                            name="RecurringBillingCycle"
                            style={{ borderColor: this.state.RecurringBillingCycleError }}
                          /> 
                          <InputGroup.Addon>of billing cycles</InputGroup.Addon>
                        </InputGroup> 
                      </FormGroup>
                    ) : null}
                  </Col>
                </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <Attributes 
                          indexKey={this.state.indexKey}
                          attributeData={this.attributeData} 
                          matrixData={this.matrixData}
                          postAttributes={(this.props.priceData && this.props.priceData.attribute) ? this.props.priceData.attribute : []}
                          postMatrix={(this.props.priceData && this.props.priceData.metrix) ? this.props.priceData.metrix : []}
                          key={Math.random()}
                        />
                      </Col>
                    </Row>
               
              </div>
            </div>
          </div>
          {/**end contract price information **/}
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    deletedContract: state.contractReducer.deletedContract,
    error: state.contractReducer.error
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { removeChildContract })
)(AdditionalPrice);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/AdditionalPrice.js